import Card from "./Card";
import me from "../Images/profile.png";
import me_transparent from "../Images/me_transparent.png"
import { Link } from 'react-router-dom';

function Me(props) {

      const me = {
      name: "Torben Gotowik",
      age: "29 years old",
      email: "webmaster@tgotowik.de",
      picture: me_transparent
    }

    return (
        <Card>
        <div className="me_wrapper">
            <div className="me_picture">
                <Link to="/"><img src={me.picture}></img></Link>
            </div>
            <div className="me_infos">
                <div>{me.name} </div>
                <div>{me.age}</div>
                <a href={`mailto:${me.email}`}>{me.email}</a>
            </div>
        </div>
        </Card>
    );
}

export default Me;